import React, { useEffect, useState, useRef } from 'react'
import { useGoogleLogin } from '@react-oauth/google';
import { useNavigate } from 'react-router-dom'
import axios from 'axios';

const VideoComponent = ({ videoUrl, imageUrl, isPlaying, setIsPlaying }) => {
    const videoRef = useRef(null);
    return (
        <div className='main-video-sec w-100'>
            <div className={isPlaying ? 'd-none' : "video-image-div pointer"}>
                <img src={imageUrl} alt="" className='play-button' onClick={() => {
                    setIsPlaying(true)
                    if (videoRef.current) {
                        videoRef.current.play()
                    }
                }} />
            </div>
            <div className={!isPlaying ? 'd-none' : 'video-div w-100'}>
                <video className="w-100" style={{ height: '34vh', objectFit: 'cover' }}
                    ref={videoRef}
                    controls
                    disablePictureInPicture
                    muted
                    autoPlay
                    src={videoUrl}
                    onClick={() => {
                        if (!isPlaying) {
                            setIsPlaying(true); videoRef.current.play()
                        } else {
                            setIsPlaying(false); videoRef.current.pause()
                        }
                    }}
                    controlsList='noplaybackrate nofullscreen nodownload'
                    // onMouseEnter={() => {setIsPlaying(true); videoRef.current.play()}}
                    // onMouseLeave={() => {if(isPlaying === true){ setIsPlaying(false); videoRef.current.pause()} else{ setIsPlaying(true); videoRef.current.play()} }} 
                    onPause={() => { setIsPlaying(false) }} onEnded={() => { setIsPlaying(false) }}></video>
            </div>
        </div>
    )
}
function ConnectGoogle() {
    const navigate = useNavigate();
    const [userInfo, setUserInfo] = useState(null);
    const [isPlaying, setIsPlaying] = useState(true);

    const handleLoginSuccess = async (tokenResponse) => {
        const { code } = tokenResponse;

        // Exchange the code for tokens at the backend
        try {
            const res = await axios.post('https://goodreviews.co/api/google-login', { code, correl_id: userInfo.correl_id });
            console.log(res, 'loginData')
            const { idToken, accessToken, refreshToken, user } = res.data;

            // Store tokens and user information in local storage
            localStorage.setItem('accessToken', accessToken);
            localStorage.setItem('refreshToken', refreshToken);
            localStorage.setItem('idToken', idToken);
            localStorage.setItem('user', JSON.stringify(user));
            navigate('/dashboard')
        } catch (error) {
            console.error('Failed to login with Google', error);
        }
    };

    const login = useGoogleLogin({
        onSuccess: handleLoginSuccess,
        onError: () => console.log('Login Failed'),
        scope: "https://www.googleapis.com/auth/business.manage",
        flow: 'auth-code',
    });

    useEffect(() => {
        let userData = JSON.parse(localStorage.getItem('userData') || '{}');
        setUserInfo(userData)
    }, [])

    return (
        <div className='bootstrap-content weblogin-page'>
            <div className="row g-0 w-100 h-100" >
                <div className="col-6 d-none d-lg-block">
                    <div className="login-left">
                        <div className="ellipse"></div>
                        {/* <h6 className='login-heading'>Tell Your Reviews </h6> */}
                        <h6 className='success-subheading'>Grow Your Business With Good Reviews</h6>
                        <img src={require('../../assets/gr-seal-logo.png')} alt="" className='login-left-image' />
                        {/* <div className={isPlaying ? "bg-color no-bg-img" : "bg-color"}>
                            <div className="image-container w-100">
                                <VideoComponent isPlaying={isPlaying} setIsPlaying={setIsPlaying} videoUrl={require('../../assets/output_HD1080.mp4')} imageUrl={require('../../assets/video-file.png')} />
                            </div>
                        </div> */}
                        <h6 className='login-desc mt-3'>Trusted By 10,000+ Global Companies of all sizes</h6>
                        <div className="row justify-content-center">
                            <div className="col mb-2">
                                <img src={require('../../assets/left-website/aws.png')} alt="" className='logos' />
                            </div>
                            <div className="col mb-2">
                                <img src={require('../../assets/left-website/microsoft.png')} alt="" className='logos' />
                            </div>
                            <div className="col mb-2">
                                <img src={require('../../assets/left-website/google-partner.png')} alt="" className='logos' />
                            </div>
                            <div className="col mb-2">
                                <img src={require('../../assets/left-website/katalon.png')} alt="" className='logos' />
                            </div>
                        </div>
                        <div className="row justify-content-center">
                            <div className="col mb-2">
                                <img src={require('../../assets/left-website/partner.png')} alt="" className='logos' />
                            </div>
                            <div className="col mb-2">
                                <img src={require('../../assets/left-website/ware.png')} alt="" className='logos' />
                            </div>
                            <div className="col mb-2">
                                <img src={require('../../assets/left-website/citrix.png')} alt="" className='logos' />
                            </div>
                            <div className="col mb-2">
                                <img src={require('../../assets/left-website/salesforce.png')} alt="" className='logos' />
                            </div>
                        </div>
                        <div className="row justify-content-center">
                            <div className="col mb-2">
                                <img src={require('../../assets/left-website/norton.png')} alt="" className='logos' />
                            </div>
                            <div className="col mb-2">
                                <img src={require('../../assets/left-website/symantec.png')} alt="" className='logos' />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-lg-6 h-100">
                    <div className="login-right">
                        <div className="login-card">
                            <div className="text-center">
                                <img src={require("../../assets/logo.png")} alt="" className='logo-image' />
                                <h6 className='login-welcometext'><strong>Hi {userInfo && userInfo.first_name}</strong></h6>
                                <p>To make the most out of our platform, <br />
                                    <strong>Please connect your Google Business Account</strong>
                                </p>
                            </div>
                            <div className="text-start">
                                <button className='text-center btn btn-white' onClick={() => { login() }}>
                                    <img src={require('../../assets/google-icon.png')} style={{ height: '35px', marginRight: '10px' }} alt="" />
                                    Connect to Google
                                </button>
                            </div>
                            <div>
                                <p className='text-center mb-0 pointer' onClick={() => { navigate('/dashboard') }}>
                                    Skip for now
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default ConnectGoogle